// src/components/ui/FooterNav.js
import React, { useState, useEffect } from "react";
import { Link, useLocation } from "react-router-dom";
import { Home, Calendar, BarChart3 } from "lucide-react";

const navItems = [
  { path: "/home", label: "ホーム", icon: Home },
  { path: "/calendar", label: "カレンダー", icon: Calendar },
  { path: "/skills", label: "スキル", icon: BarChart3 }, // パスを修正: skill → skills
];

const FooterNav = () => {
  const location = useLocation();
  const [windowWidth, setWindowWidth] = useState(window.innerWidth);
  const hiddenPaths = ["/login", "/"];

  // ウィンドウサイズを監視
  useEffect(() => {
    const handleResize = () => {
      setWindowWidth(window.innerWidth);
    };
    
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  // ログインページまたはデスクトップサイズでは非表示
  if (hiddenPaths.includes(location.pathname) || windowWidth >= 768) return null;

  return (
    <nav
      style={{
        position: "fixed",
        bottom: 0,
        left: 0,
        right: 0,
        height: "70px",
        background: "rgba(255, 255, 255, 0.9)",
        backdropFilter: "blur(10px)",
        borderTop: "1px solid rgba(220, 220, 220, 0.5)",
        display: "flex",
        justifyContent: "space-around",
        alignItems: "center",
        boxShadow: "0 -4px 20px rgba(0, 0, 0, 0.08)",
        zIndex: 1000,
        padding: "0 10px",
      }}
    >
      {navItems.map((item) => {
        // 現在のパスがこのアイテムのパスで始まるか確認（サブルート対応）
        const isActive = location.pathname === item.path || 
                         location.pathname.startsWith(`${item.path}/`);
        
        // アイテムごとの色を定義
        const getItemColor = (path) => {
          switch(path) {
            case "/home": return { bg: "#E3F2FD", color: "#1976D2" };
            case "/calendar": return { bg: "#E8F5E9", color: "#2E7D32" };
            case "/skills": return { bg: "#F3E5F5", color: "#7B1FA2" };
            case "/tasks": return { bg: "#FFF3E0", color: "#E65100" };
            default: return { bg: "#F5F5F5", color: "#757575" };
          }
        };
        
        const itemColors = getItemColor(item.path);
        const IconComponent = item.icon;
        
        return (
          <Link
            key={item.path}
            to={item.path}
            style={{
              textDecoration: "none",
              textAlign: "center",
              color: isActive ? itemColors.color : "#757575",
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              justifyContent: "center",
              flex: 1,
              height: "100%",
              position: "relative",
              transition: "transform 0.2s, color 0.2s",
              transform: isActive ? "translateY(-5px)" : "translateY(0)",
            }}
            onMouseDown={(e) => {
              e.currentTarget.style.transform = "scale(0.95)";
            }}
            onMouseUp={(e) => {
              e.currentTarget.style.transform = isActive ? "translateY(-5px)" : "translateY(0)";
            }}
            onTouchStart={(e) => {
              e.currentTarget.style.transform = "scale(0.95)";
            }}
            onTouchEnd={(e) => {
              e.currentTarget.style.transform = isActive ? "translateY(-5px)" : "translateY(0)";
            }}
          >
            {/* アイコンコンテナ */}
            <div
              style={{
                width: "42px",
                height: "42px",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                backgroundColor: isActive ? itemColors.bg : "transparent",
                borderRadius: "12px",
                marginBottom: "2px",
                transition: "all 0.3s",
                transform: isActive ? "scale(1)" : "scale(0.85)",
                boxShadow: isActive ? `0 3px 10px rgba(0, 0, 0, 0.1)` : "none",
              }}
            >
              <IconComponent 
                size={22} 
                color={isActive ? itemColors.color : "#757575"}
                strokeWidth={isActive ? 2.5 : 2}
              />
            </div>
            
            {/* ラベル */}
            <div
              style={{
                fontSize: "0.65rem",
                fontWeight: isActive ? "600" : "500",
                opacity: isActive ? 1 : 0.7,
                transition: "all 0.3s",
              }}
            >
              {item.label}
            </div>
            
            {/* アクティブインジケーター */}
            {isActive && (
              <div
                style={{
                  position: "absolute",
                  bottom: -10,
                  left: "50%",
                  width: "5px",
                  height: "5px",
                  backgroundColor: itemColors.color,
                  borderRadius: "50%",
                  transform: "translateX(-50%)",
                }}
              />
            )}
          </Link>
        );
      })}
      
      {/* アニメーションスタイル */}
      <style>
        {`
          @keyframes pulse {
            0% { transform: scale(1); }
            50% { transform: scale(1.05); }
            100% { transform: scale(1); }
          }
        `}
      </style>
    </nav>
  );
};

export default FooterNav;